import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { Month } from "../../models/month.model";

export namespace MonthActions {

  @logDispatcher
  export class GetMonths {
    static readonly type = '[Month] GetMonths';
    constructor() {}
  }

  @logDispatcher
  export class GetMonthsSuccess {
    static readonly type = '[Month] GetMonthsSuccess';
    constructor(public months: Month[]) {}
  }

  @logDispatcher
  export class GetMonthsFail {
    static readonly type = '[Month] GetMonthsFail';
    constructor(public error: any) {}
  }
}
